import * as ng from 'angular';
import {ArchiSmallServices} from '../../../../services/archismall.service';
import {TMP_BUCKET} from '../../../../config';

class ConservazioneCaricaDocumentoStep1Controller implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    '$state',
    '$stateParams',
    '$http',
    'configuration',
    'store',
    'jwtHelper',
    'ArchiSmallServices',
    '$sce',
    '$uibModal',
    '$timeout',
    '$q'
  ];

  constructor(
    private $scope: any,
    private $rootScope: any,
    private $state: any,
    private $stateParams: ng.ui.IStateParamsService,
    private $http: ng.IHttpService,
    private configuration: any,
    private store: ng.a0.storage.IStoreService,
    private jwtHelper: any,
    private ArchiSmallServices: ArchiSmallServices,
    private $sce: any,
    private $uibModal: ng.ui.bootstrap.IModalService,
    private $timeout: ng.ITimeoutService,
    private $q: ng.IQService
  ) {
    $rootScope.readyToUse = true;
    $scope.pageHeader = 'Carica Documenti';
    $scope.ResponseReceivedTimeout = false;
    $scope.message = '';
    $scope.isLoading = false;
    $rootScope.user = store.get('user');

    if ($rootScope.user !== undefined) {
      if ($stateParams.classeDocumentale === 'fatture-attive') {
        $scope.maxFilesToUpload = configuration.fattureAttiveMaxFilesToUpload;
        $scope.message = 'Clicca o trascina qui i tuoi files';
      }
    }

    $scope.filesIndex = 0;
    let filesItem = {'file_id': '', 'file_name': '', 'short_name': '', file_icon: ''};

    $scope.trustAsHtml = (value) => {
      return $sce.trustAsHtml(value);
    };
    let getSettingsDefault = () => {
      return {
        username: $rootScope.currentUser().sub,
        classeDocumentale: $stateParams.classeDocumentale,
        tipoDocumento: '',
        files: [],
        periodoEsercizio: (new Date().getFullYear() - 1).toString(),
        meseInizio: '',
        meseFine: '',
        digitalSignatureAndMetadatiAgreement: '',
        queueId: '',
        delete_icon: '',
      };
    };
    $scope.getSettingsDefault = getSettingsDefault;

    $scope.classeDocumentale = [
      {
        'key': 'pec-posta-elettronica-certificata',
        'name': 'PEC - Posta Elettronica Certificata',
        'icon': 'icon-icon_pec',
        'iconSize': 'farchismall-1-2x'
      },
      {
        'key': 'pec-notifiche-pec',
        'name': 'PEC - Notifiche PEC',
        'icon': 'icon-icon_pec',
        'iconSize': 'farchismall-1-2x'
      },
      {
        'key': 'corrispondenza-ordinaria',
        'name': 'Corrispondenza Ordinaria',
        'icon': 'icon-icon_pec',
        'iconSize': 'farchismall-1-2x'
      },
      {
        'key': 'fatture-attive',
        'name': 'Fatture Attive',
        'icon': 'icon-icon_fatture_attive',
        'iconSize': 'farchismall-1-2x'
      }, {
        'key': 'notifiche-sdi',
        'name': 'Notifiche SdI',
        'icon': 'icon-icon_fatture_attive',
        'iconSize': 'farchismall-1-2x'
      },
      {
        'key': 'certificazione-unica',
        'name': 'Certificazione Unica',
        'icon': 'icon-icon_fatture_attive',
        'iconSize': 'farchismall-1-2x'
      },
      {
        'key': 'documenti-bancari',
        'name': 'Documenti Bancari',
        'icon': 'icon-icon_fatture_attive',
        'iconSize': 'farchismall-1-2x'
      },
      {
        'key': 'manuali',
        'name': 'Manuali',
        'icon': 'icon-icon_fatture_passive',
        'iconSize': 'farchismall-1-2x'
      },
      {
        'key': 'modello-intrastat',
        'name': 'Modello Intrastat',
        'icon': 'icon-icon_fatture_passive',
        'iconSize': 'farchismall-1-2x'
      },
      {
        'key': 'libri-sociali',
        'name': 'Libri Sociali',
        'icon': 'icon-icon_fatture_passive',
        'iconSize': 'farchismall-1-2x'
      },
      {
        'key': 'registro-liquidazioni-iva',
        'name': 'Registro Liquidazioni Iva',
        'icon': 'icon-icon_fatture_passive',
        'iconSize': 'farchismall-1-2x'
      },
      {
        'key': 'fattura-passiva',
        'name': 'Fatture Passive',
        'icon': 'icon-icon_fatture_passive',
        'iconSize': 'farchismall-1-2x'
      },
      {
        'key': 'contratti-da-fornitore',
        'name': 'Contratti da Fornitore',
        'icon': 'icon-icon_fatture_passive',
        'iconSize': 'farchismall-1-2x'
      },
      {
        'key': 'contratti-a-cliente',
        'name': 'Contratti a Cliente',
        'icon': 'icon-icon_fatture_passive',
        'iconSize': 'farchismall-1-2x'
      },
      {
        'key': 'ordini-a-fornitore',
        'name': 'Ordini a Fornitore',
        'icon': 'icon-icon_fatture_passive',
        'iconSize': 'farchismall-1-2x'
      },
      {
        'key': 'ordini-da-cliente',
        'name': 'Ordini da Cliente',
        'icon': 'icon-icon_fatture_passive',
        'iconSize': 'farchismall-1-2x'
      },
      {'key': 'ddt-attivo', 'name': 'DDT Attivi', 'icon': 'icon-icon_ddt_attivi', 'iconSize': 'farchismall-1-2x'},
      {'key': 'ddt-passivo', 'name': 'DDT Passivi', 'icon': 'icon-icon_ddt_passivi', 'iconSize': 'farchismall-1-2x'},
      {'key': 'lul', 'name': 'LUL', 'icon': 'icon-icon_LUL', 'iconSize': 'farchismall-1-2x'},
      {'key': 'altro-documento', 'name': 'Altri Documenti', 'icon': 'icon-icon_altro', 'iconSize': 'farchismall-1-2x'},
      {'key': 'libro-giornale', 'name': 'Libri Giornale', 'icon': 'icon-icon_libri', 'iconSize': 'farchismall-1-2x'},
      {'key': 'prima-nota', 'name': 'Registro Prima Nota', 'icon': 'icon-icon_libri', 'iconSize': 'farchismall-1-2x'},
      {
        'key': 'giornali-schede-magazzino',
        'name': 'Giornali e Schede di Magazzino',
        'icon': 'icon-icon_libri',
        'iconSize': 'farchismall-1-2x'
      },
      {'key': 'libro-inventari', 'name': 'Libri Inventari', 'icon': 'icon-icon_libri', 'iconSize': 'farchismall-1-2x'},
      {'key': 'registro-omaggi', 'name': 'Registro Omaggi', 'icon': 'icon-icon_libri', 'iconSize': 'farchismall-1-2x'},
      {'key': 'libro-mastro', 'name': 'Libri Mastro', 'icon': 'icon-icon_libri', 'iconSize': 'farchismall-1-2x'},
      {'key': 'libro-cespiti', 'name': 'Libri Cespiti', 'icon': 'icon-icon_libri', 'iconSize': 'farchismall-1-2x'},
      {'key': 'altri-libri', 'name': 'Altri Libri', 'icon': 'icon-icon_libri', 'iconSize': 'farchismall-1-2x'},
      {
        'key': 'libro-registri-iva',
        'name': 'Registri IVA',
        'icon': 'icon-icon_libri',
        'iconSize': 'farchismall-1-2x'
      },
      {
        'key': 'registro-riepilogativo-iva',
        'name': 'Registro Riepilogativo Iva',
        'icon': 'icon-icon_libri',
        'iconSize': 'farchismall-1-2x'
      },
      {
        'key': 'altri-registri',
        'name': 'Altri Registri',
        'icon': 'icon-icon_libri',
        'iconSize': 'farchismall-1-2x'
      },
      {
        'key': 'registro-fatture-acquisto',
        'name': 'Registro Fatture Acquisto',
        'icon': 'icon-icon_libri',
        'iconSize': 'farchismall-1-2x'
      },
      {
        'key': 'registro-fatture-vendita',
        'name': 'Registro Fatture Vendita',
        'icon': 'icon-icon_libri',
        'iconSize': 'farchismall-1-2x'
      },
      {
        'key': 'modello-f23-f24',
        'name': 'Modello F23 - F24',
        'icon': 'icon-icon_altro',
        'iconSize': 'farchismall-1-2x'
      },
      {
        'key': 'modello-770',
        'name': 'Modello 770',
        'icon': 'icon-icon_altro',
        'iconSize': 'farchismall-1-2x'
      },
      {
        'key': 'verbali-verifica-scarto',
        'name': 'Verbali di Verifica e di Scarto',
        'icon': 'icon-icon_altro',
        'iconSize': 'farchismall-1-2x'
      },
      {
        'key': 'nomine-deleghe-conservazione',
        'name': 'Nomine e Deleghe di Conservazione',
        'icon': 'icon-icon_altro',
        'iconSize': 'farchismall-1-2x'
      },
      {
        'key': 'registro-corrispettivi-iva',
        'name': 'Registro Corrispettivi Iva',
        'icon': 'icon-icon_altro',
        'iconSize': 'farchismall-1-2x'
      },
      {
        'key': 'dichiarazioni-fiscali',
        'name': 'Dichiarazioni Fiscali',
        'icon': 'icon-icon_altro',
        'iconSize': 'farchismall-1-2x'
      },
      {
        'key': 'ricevute-fiscali',
        'name': 'Ricevute Fiscali',
        'icon': 'icon-icon_altro',
        'iconSize': 'farchismall-1-2x'
      },
      {
        'key': 'registro-beni-di-terzi',
        'name': 'Registro Beni di Terzi',
        'icon': 'icon-icon_altro',
        'iconSize': 'farchismall-1-2x'
      },
      {
        'key': 'registro-unico-iva',
        'name': 'Registro Unico Iva',
        'icon': 'icon-icon_altro',
        'iconSize': 'farchismall-1-2x'
      },
      {
        'key': 'modello-730',
        'name': 'Modello 730',
        'icon': 'icon-icon_altro',
        'iconSize': 'farchismall-1-2x'
      },
      {
        'key': 'schede-cliniche',
        'name': 'Schede Cliniche',
        'icon': 'icon-icon_altro',
        'iconSize': 'farchismall-1-2x'
      },
      {
        'key': 'registro-rifiuti',
        'name': 'Registro Carico Scarico Rifiuti',
        'icon': 'icon-icon_altro',
        'iconSize': 'farchismall-1-2x'
      },
      {
        'key': 'cm',
        'name': 'CM',
        'icon': 'icon-icon_altro',
        'iconSize': 'farchismall-1-2x'
      },
      {
        'key': 'cmr',
        'name': 'CMR',
        'icon': 'icon-icon_altro',
        'iconSize': 'farchismall-1-2x'
      },
      {
        'key': 'formulario-identificativo-rifiuti',
        'name': 'Formulario Identificativo Rifiuti',
        'icon': 'icon-icon_altro',
        'iconSize': 'farchismall-1-2x'
      },
      {
        'key': 'dichiarazioni-intento-attive',
        'name': 'Dichiarazioni Intento Attive',
        'icon': 'icon-icon_altro',
        'iconSize': 'farchismall-1-2x'
      },
      {
        'key': 'documenti-doganali-emessi',
        'name': 'Documenti Doganali Emessi',
        'icon': 'icon-icon_altro',
        'iconSize': 'farchismall-1-2x'
      },
      {
        'key': 'documenti-doganali-ricevuti',
        'name': 'Documenti Doganali Ricevuti',
        'icon': 'icon-icon_altro',
        'iconSize': 'farchismall-1-2x'
      },
      {
        'key': 'dichiarazioni-intento-passive',
        'name': 'Dichiarazioni Intento Passive',
        'icon': 'icon-icon_altro',
        'iconSize': 'farchismall-1-2x'
      },
      {
        'key': 'modello-unico-dichiarazione-ambientale',
        'name': 'Modello Unico Dichiarazione Ambientale',
        'icon': 'icon-icon_altro',
        'iconSize': 'farchismall-1-2x'
      },
      {
        'key': 'note-spese-e-trasferte',
        'name': 'Note Spese e Trasferte',
        'icon': 'icon-icon_altro',
        'iconSize': 'farchismall-1-2x'
      },
      {
        'key': 'pod',
        'name': 'POD',
        'icon': 'icon-icon_altro',
        'iconSize': 'farchismall-1-2x'
      },
      {
        'key': 'bilanci',
        'name': 'Bilanci',
        'icon': 'icon-icon_altro',
        'iconSize': 'farchismall-1-2x'
      }
    ].sort(({name: a}, {name: b}) => a.localeCompare(b)).filter(classe => $rootScope.user.classiDocumentali[classe.key.split('-').join('_')]);

    $scope.iconSize = 'farchismall-1-2x';

    $scope.isClasseDocumentaleEnabled = (classeDocumentale: string) => {
      if (classeDocumentale === 'fatture-attive-abbyy') {
        return $rootScope.user.use_abbyy === true;
      }

      if (classeDocumentale === 'fatture-attive') {
        return $rootScope.user.use_abbyy !== true;
      }
      return true;
    };
    // if we'll support other file format we should check if the new extension
    // is coded in this file ArchiSmallSuite/ArchiSmallWorker/src/main/resources/content-type.properties
    // if it is not coded, we must add it
    $scope.allowedExtensions = {
      'pec-posta-elettronica-certificata': '[\'eml\']',
      'pec-notifiche-pec': '[\'eml\']',
      'corrispondenza-ordinaria': '[\'eml\', \'msg\', \'pst\', \'pdf\', \'p7m\',\'p7m.tsd\']',
      'libro-contabile': '[\'pdf\',\'txt\']',
      'registro-contabile': '[\'pdf\',\'txt\']',
      'fatture-attive': '[\'xml\', \'pdf\', \'p7m\', \'p7m.tsd\']',
      'fattura-passiva': '[\'xml\', \'pdf\', \'p7m\', \'p7m.tsd\']',
      'notifiche-sdi': '[\'xml\']',
      'certificazione-unica': '[\'pdf\',\'p7m\',\'p7m.tsd\']',
      'libri-sociali': '[\'pdf\',\'p7m\',\'p7m.tsd\']',
      'registro-liquidazioni-iva': '[\'pdf\',\'p7m\',\'p7m.tsd\']',
      'registro-rifiuti': '[\'xml\',\'pdf\']',
      'documenti-bancari': '[\'pdf\',\'txt\']',
      'manuali': '[\'pdf\', \'xls\', \'xlsx\', \'txt\', \'doc\', \'docx\',\'p7m\']',
      'modello-dichiarativo': '[\'pdf\']',
      'modello-versamento': '[\'pdf\']',
      'modello-intrastat': '[\'xml\', \'pdf\', \'p7m\', \'p7m.tsd\']',
      'bollette': '[\'pdf\']',
      'altro-documento': '[\'pdf\', \'txt\', \'tiff\', \'jpg\', \'jpeg\', \'docx\', \'xlsx\', \'pptx\', \'xml\', \'ods\',  \'odp\', \'odg\', \'odb\', \'eml\', \'msg\']',
      'contratti-da-fornitore': '[\'pdf\',\'p7m\',\'p7m.tsd\']',
      'contratti-a-cliente': '[\'pdf\',\'p7m\',\'p7m.tsd\']',
      'ordini-a-fornitore': '[\'pdf\',\'p7m\',\'p7m.tsd\']',
      'ordini-da-cliente': '[\'pdf\',\'p7m\',\'p7m.tsd\']',
      'ddt-attivo': '[\'pdf\']',
      'ddt-passivo': '[\'pdf\']',
      'lul': '[\'pdf\']',
      'libro-giornale': '[\'pdf\',\'txt\']',
      'prima-nota': '[\'pdf\',\'txt\']',
      'giornali-schede-magazzino': '[\'pdf\',\'txt\']',
      'libro-inventari': '[\'pdf\',\'txt\']',
      'registro-omaggi': '[\'pdf\',\'txt\']',
      'libro-mastro': '[\'pdf\',\'txt\']',
      'libro-cespiti': '[\'pdf\',\'txt\']',
      'altri-libri': '[\'pdf\',\'txt\']',
      'libro-registri-iva': '[\'pdf\',\'txt\']',
      'registro-riepilogativo-iva': '[\'pdf\',\'txt\']',
      'altri-registri': '[\'pdf\',\'txt\']',
      'registro-fatture-acquisto': '[\'pdf\',\'txt\']',
      'registro-fatture-vendita': '[\'pdf\',\'txt\']',
      'modello-f23-f24': '[\'pdf\']',
      'modello-770': '[\'pdf\']',
      'registro-corrispettivi-iva': '[\'pdf\']',
      'dichiarazioni-fiscali': '[\'xml\',\'pdf\']',
      'ricevute-fiscali': '[\'xml\',\'pdf\']',
      'registro-beni-di-terzi': '[\'pdf\']',
      'registro-unico-iva': '[\'pdf\']',
      'verbali-verifica-scarto': '[\'pdf\']',
      'nomine-deleghe-conservazione': '[\'pdf\']',
      'schede-cliniche': '[\'pdf\']',
      'modello-730': '[\'pdf\']',
      'cm': '[\'pdf\']',
      'cmr': '[\'pdf\']',
      'modello-unico-dichiarazione-ambientale': '[\'xml\',\'pdf\',\'mud\',\'txt\',\'csv\']',
      'note-spese-e-trasferte': '[\'pdf\']',
      'formulario-identificativo-rifiuti': '[\'xfir\',\'pdf\',\'xml\']',
      'pod': '[\'pdf\']',
      'dichiarazioni-intento-attive': '[\'pdf\']',
      'documenti-doganali-emessi': '[\'xml\',\'pdf\',\'p7m\',\'p7m.tsd\']',
      'documenti-doganali-ricevuti': '[\'xml\',\'pdf\',\'p7m\',\'p7m.tsd\']',
      'dichiarazioni-intento-passive': '[\'pdf\']',
      'bilanci': '[\'pdf\']',
    };

    $scope.signedExtensions = {
      'pec-posta-elettronica-certificata': '[]',
      'pec-notifiche-pec': '[]',
      'corrispondenza-ordinaria': '[\'p7m\', \'p7m.tsd\']',
      'libro-contabile': '[\'p7m\', \'p7m.tsd\']',
      'modello-intrastat': '[\'p7m\', \'p7m.tsd\']',
      'libri-sociali': '[\'p7m\', \'p7m.tsd\']',
      'registro-liquidazioni-iva': '[\'p7m\', \'p7m.tsd\']',
      'registro-contabile': '[\'p7m\', \'p7m.tsd\']',
      'registro-rifiuti': '[\'p7m\', \'p7m.tsd\']',
      'fatture-attive': '[\'p7m\', \'p7m.tsd\']',
      'notifiche-sdi': '[\'p7m\', \'p7m.tsd\']',
      'certificazione-unica': '[\'p7m\', \'p7m.tsd\']',
      'documenti-bancari': '[\'p7m\', \'p7m.tsd\']',
      'manuali': '[\'p7m\', \'p7m.tsd\']',
      'modello-dichiarativo': '[\'p7m\', \'p7m.tsd\']',
      'modello-versamento': '[\'p7m\', \'p7m.tsd\']',
      'bollette': '[\'p7m\', \'p7m.tsd\']',
      'altro-documento': '[\'p7m\', \'p7m.tsd\']',
      'fattura-passiva': '[\'p7m\', \'p7m.tsd\']',
      'contratti-da-fornitore': '[\'p7m\', \'p7m.tsd\']',
      'contratti-a-cliente': '[\'p7m\', \'p7m.tsd\']',
      'ordini-a-fornitore': '[\'p7m\', \'p7m.tsd\']',
      'ordini-da-cliente': '[\'p7m\', \'p7m.tsd\']',
      'ddt-attivo': '[\'p7m\', \'p7m.tsd\']',
      'ddt-passivo': '[\'p7m\', \'p7m.tsd\']',
      'lul': '[\'p7m\', \'p7m.tsd\']',
      'libro-giornale': '[\'p7m\', \'p7m.tsd\']',
      'prima-nota': '[\'p7m\', \'p7m.tsd\']',
      'giornali-schede-magazzino': '[\'p7m\', \'p7m.tsd\']',
      'libro-inventari': '[\'p7m\', \'p7m.tsd\']',
      'registro-omaggi': '[\'p7m\', \'p7m.tsd\']',
      'libro-mastro': '[\'p7m\', \'p7m.tsd\']',
      'libro-cespiti': '[\'p7m\', \'p7m.tsd\']',
      'altri-libri': '[\'p7m\', \'p7m.tsd\']',
      'registro-corrispettivi-iva': '[\'p7m\', \'p7m.tsd\']',
      'dichiarazioni-fiscali': '[\'p7m\', \'p7m.tsd\']',
      'ricevute-fiscali': '[\'p7m\', \'p7m.tsd\']',
      'registro-beni-di-terzi': '[\'p7m\', \'p7m.tsd\']',
      'registro-unico-iva': '[\'p7m\', \'p7m.tsd\']',
      'libro-registri-iva': '[\'p7m\', \'p7m.tsd\']',
      'registro-riepilogativo-iva': '[\'p7m\', \'p7m.tsd\']',
      'altri-registri': '[\'p7m\', \'p7m.tsd\']',
      'registro-fatture-acquisto': '[\'p7m\', \'p7m.tsd\']',
      'registro-fatture-vendita': '[\'p7m\', \'p7m.tsd\']',
      'modello-f23-f24': '[\'p7m\', \'p7m.tsd\']',
      'modello-770': '[\'p7m\', \'p7m.tsd\']',
      'verbali-verifica-scarto': '[\'p7m\', \'p7m.tsd\']',
      'nomine-deleghe-conservazione': '[\'p7m\', \'p7m.tsd\']',
      'schede-cliniche': '[\'p7m\', \'p7m.tsd\']',
      'modello-730': '[\'p7m\', \'p7m.tsd\']',
      'cm': '[\'p7m\', \'p7m.tsd\']',
      'cmr': '[\'p7m\', \'p7m.tsd\']',
      'formulario-identificativo-rifiuti': '[\'p7m\', \'p7m.tsd\']',
      'dichiarazioni-intento-attive': '[\'p7m\', \'p7m.tsd\']',
      'documenti-doganali-emessi': '[\'p7m\', \'p7m.tsd\']',
      'documenti-doganali-ricevuti': '[\'p7m\', \'p7m.tsd\']',
      'dichiarazioni-intento-passive': '[\'p7m\', \'p7m.tsd\']',
      'modello-unico-dichiarazione-ambientale': '[\'p7m\', \'p7m.tsd\']',
      'note-spese-e-trasferte': '[\'p7m\', \'p7m.tsd\']',
      'pod': '[\'p7m\', \'p7m.tsd\']',
      'bilanci': '[\'p7m\', \'p7m.tsd\']',
    };

    $scope.setValidExtensions = (classeDocumentale) => {
      return $scope.allowedExtensions[classeDocumentale];
    };

    $scope.getSignedExtensions = (classeDocumentale) => {
      return $scope.signedExtensions[classeDocumentale];
    };

    $scope.checkOption = (option) => {
      $rootScope.readyToUse = false;

      switch (option) {
        case 'fatture-attive':
          $scope.maxFilesToUpload = configuration.fattureAttiveMaxFilesToUpload;
          $scope.message = 'Clicca o trascina qui i tuoi files';
          break;
        default:
          $scope.maxFilesToUpload = 1;
          $scope.message = 'Clicca o trascina qui il tuo file';
          break;
      }
      $scope.getConservazioneSettings();

    };

    $scope.settings = getSettingsDefault();
    $scope.uploadFileOnGoogleStorageCallback = (dropzoneId: string, res, filename: string) => {
      if (res === false) {
        $timeout(() => {
          $rootScope.filesUploadedNumber--;
        });
        return;
      }
      if ($scope.filesIndex < $scope.maxFilesToUpload || $scope.settings.files.length === 0) {
        $scope.settings.files.push(jQuery.extend(true, {}, filesItem));
      } else if ($scope.maxFilesToUpload === 1) {
        $scope.filesIndex = 0;
        $rootScope.filesUploadedNumber--;
      } else {
        $rootScope.alert('warning', 'Puoi caricare solo ' + $scope.maxFilesToUpload + ' File(s) !');
        $rootScope.filesUploadedNumber--;
        return;
      }

      $scope.settings.files[$scope.filesIndex].file_id = res.id;
      $scope.settings.files[$scope.filesIndex].file_name = res.name;
      $scope.settings.files[$scope.filesIndex].short_name = filename;
      $scope.extension = filename.split('.').pop().toLowerCase();
      $scope.delete_file = '<a ng-click=\'deleteFile($index)\'><i class=\'icon-icon_erase farchismall-1-5x delete-icon\'></i></a>';
      switch ($scope.extension) {
        case 'pdf':
          $scope.icon = '<i class=\'icon-icon_file farchismall-1-5x\'></i>';
          break;
        default:
          $scope.icon = '<i class=\'icon-icon_file farchismall-1-5x\'></i>';
      }

      $scope.settings.files[$scope.filesIndex].file_icon = $scope.icon;
      $scope.settings.delete_icon = $scope.delete_file;
      $scope.filesIndex++;


      $scope.setConservazioneSettings();
    };

    let uploadedFilesAreOk = () => {
      for (let i = 0; i < $scope.settings.files.length; i++) {
        if ((!$scope.settings.files[i].file_id) ||
          (!$scope.settings.files[i].file_name) ||
          (!$scope.settings.files[i].short_name)) {
          return false;
        }
      }
      return true;
    };

    $scope.deleteFile = (index: number) => {
      $scope.settings.files.splice(index, 1);
      $scope.filesIndex--;
      $rootScope.filesUploadedNumber--;

      if ($scope.filesIndex > 0) {
        $scope.setConservazioneSettings();
      } else {
        $rootScope.removeConservazioneSettingsFiles($scope.settings.classeDocumentale);
      }

    };

    $scope.next = () => {

      $scope.isLoading = true;
      this.ArchiSmallServices.validateDigitalSignature(TMP_BUCKET, encodeURIComponent($scope.settings.files[0].file_name))
        .then((response: any) => {
          $scope.isLoading = false;
          if (response) {
            $scope.goToNextStep();
            return;
          }

          let digitalSignatureMissingModalInstance = $uibModal.open({
            animation: true,
            component: 'digitalSignatureMissingModal',
            size: 'lg',
            windowClass: 'center-modal',
            backdrop: 'static',
            keyboard: false,
            resolve: {}
          });
          digitalSignatureMissingModalInstance.result.then((item) => {
            if (item) {
              $scope.goToNextStep();
            }
          }, () => {
            // ?
          });
        }, (error) => {
          $scope.isLoading = false;
          $rootScope.alert('error', error);
        });

      return;
    };

    $scope.goToNextStep = () => {
      let userSettingsLocalStorageName = '';

      switch ($scope.settings.classeDocumentale.key) {
        case 'pec-posta-elettronica-certificata':
          userSettingsLocalStorageName = 'caricaPecPostaElettronicaCertificata';
          break;
        case 'pec-notifiche-pec':
          userSettingsLocalStorageName = 'caricaPecNotifichePec';
          break;
        case 'corrispondenza-ordinaria':
          userSettingsLocalStorageName = 'caricaCorrispondenzaOrdinaria';
          break;
        case 'libro-contabile':
          userSettingsLocalStorageName = 'caricaDocumentoLibroContabile';
          break;
        case 'registro-contabile':
          userSettingsLocalStorageName = 'caricaDocumentoRegistroContabile';
          break;
        case 'modello-dichiarativo':
          userSettingsLocalStorageName = 'caricaDocumentoModelloDichiarativo';
          break;
        case 'modello-versamento':
          userSettingsLocalStorageName = 'caricaDocumentoModelloVersamento';
          break;
        case 'bollette':
          userSettingsLocalStorageName = 'caricaDocumentoBollette';
          break;
        case 'altro-documento':
          userSettingsLocalStorageName = 'caricaDocumentoAltroDocumento';
          break;
        case 'fattura-passiva':
          userSettingsLocalStorageName = 'caricaDocumentoFatturaPassiva';
          break;
        case 'registro-rifiuti':
          userSettingsLocalStorageName = 'caricaDocumentoRegistroRifiuti';
          break;
        case 'contratti-da-fornitore':
          userSettingsLocalStorageName = 'caricaDocumentoContrattiDaFornitore';
          break;
        case 'contratti-a-cliente':
          userSettingsLocalStorageName = 'caricaDocumentoContrattiACliente';
          break;
        case 'ordini-a-fornitore':
          userSettingsLocalStorageName = 'caricaDocumentoOrdiniAFornitore';
          break;
        case 'ordini-da-cliente':
          userSettingsLocalStorageName = 'caricaDocumentoOrdiniDaCliente';
          break;
        case 'ddt-attivo':
          userSettingsLocalStorageName = 'caricaDocumentoDDTAttivo';
          break;
        case 'ddt-passivo':
          userSettingsLocalStorageName = 'caricaDocumentoDDTPassivo';
          break;
        case 'lul':
          userSettingsLocalStorageName = 'caricaDocumentoLUL';
          break;
        case 'fatture-attive':
          userSettingsLocalStorageName = 'caricaDocumentoFattureAttive';
          break;
        case 'notifiche-sdi':
          userSettingsLocalStorageName = 'caricaDocumentoNotificheSdi';
          break;
        case 'certificazione-unica':
          userSettingsLocalStorageName = 'caricaDocumentoCertificazioneUnica';
          break;
        case 'documenti-bancari':
          userSettingsLocalStorageName = 'caricaDocumentoDocumentiBancari';
          break;
        case 'manuali':
          userSettingsLocalStorageName = 'caricaDocumentoManuali';
          break;
        case 'modello-intrastat':
          userSettingsLocalStorageName = 'caricaDocumentoModelloIntrastat';
          break;
        case 'libri-sociali':
          userSettingsLocalStorageName = 'caricaDocumentoLibriSociali';
          break;
        case 'registro-liquidazioni-iva':
          userSettingsLocalStorageName = 'caricaDocumentoRegistroLiquidazioniIva';
          break;
        case 'libro-giornale':
          userSettingsLocalStorageName = 'caricaDocumentoLibroGiornale';
          break;
        case 'prima-nota':
          userSettingsLocalStorageName = 'caricaDocumentoPrimaNota';
          break;
        case 'giornali-schede-magazzino':
          userSettingsLocalStorageName = 'caricaDocumentoGiornaliSchedeMagazzino';
          break;
        case 'libro-inventari':
          userSettingsLocalStorageName = 'caricaDocumentoLibroInventari';
          break;
        case 'registro-omaggi':
          userSettingsLocalStorageName = 'caricaDocumentoRegistroOmaggi';
          break;
        case 'libro-mastro':
          userSettingsLocalStorageName = 'caricaDocumentoLibroMastro';
          break;
        case 'libro-cespiti':
          userSettingsLocalStorageName = 'caricaDocumentoLibroCespiti';
          break;
        case 'altri-libri':
          userSettingsLocalStorageName = 'caricaDocumentoAltriLibri';
          break;
        case 'libro-registri-iva':
          userSettingsLocalStorageName = 'caricaDocumentoLibroRegistriIva';
          break;
        case 'registro-riepilogativo-iva':
          userSettingsLocalStorageName = 'caricaDocumentoRegistroRiepilogativoIva';
          break;
        case 'altri-registri':
          userSettingsLocalStorageName = 'caricaDocumentoAltriRegistri';
          break;
        case 'registro-fatture-acquisto':
          userSettingsLocalStorageName = 'caricaDocumentoRegistroFattureAcquisto';
          break;
        case 'registro-fatture-vendita':
          userSettingsLocalStorageName = 'caricaDocumentoRegistroFattureVendita';
          break;
        case 'modello-f23-f24':
          userSettingsLocalStorageName = 'caricaDocumentoModelloF23F24';
          break;
        case 'modello-770':
          userSettingsLocalStorageName = 'caricaDocumentoModello770';
          break;
        case 'verbali-verifica-scarto':
          userSettingsLocalStorageName = 'caricaDocumentoVerbaliVerificaScarto';
          break;
        case 'nomine-deleghe-conservazione':
          userSettingsLocalStorageName = 'caricaDocumentoNomineDelegheConservazione';
          break;
        case 'registro-corrispettivi-iva':
          userSettingsLocalStorageName = 'caricaDocumentoRegistroCorrispettiviIva';
          break;
        case 'dichiarazioni-fiscali':
          userSettingsLocalStorageName = 'caricaDocumentoDichiarazioniFiscali';
          break;
        case 'ricevute-fiscali':
          userSettingsLocalStorageName = 'caricaDocumentoRicevuteFiscali';
          break;
        case 'registro-beni-di-terzi':
          userSettingsLocalStorageName = 'caricaDocumentoRegistroBeniDiTerzi';
          break;
        case 'registro-unico-iva':
          userSettingsLocalStorageName = 'caricaDocumentoRegistroUnicoIva';
          break;
        case 'schede-cliniche':
          userSettingsLocalStorageName = 'caricaDocumentoSchedeCliniche';
          break;
        case 'modello-730':
          userSettingsLocalStorageName = 'caricaDocumentoModello730';
          break;
        case 'cm':
          userSettingsLocalStorageName = 'caricaDocumentoCM';
          break;
        case 'cmr':
          userSettingsLocalStorageName = 'caricaDocumentoCMR';
          break;
        case 'formulario-identificativo-rifiuti':
          userSettingsLocalStorageName = 'caricaDocumentoFormularioIdetificativoRifiuti';
          break;
        case 'dichiarazioni-intento-attive':
          userSettingsLocalStorageName = 'caricaDocumentoDichiarazioniIntentoAttive';
          break;
        case 'dichiarazioni-intento-passive':
          userSettingsLocalStorageName = 'caricaDocumentoDichiarazioniIntentoPassive';
          break;
        case 'documenti-doganali-emessi':
          userSettingsLocalStorageName = 'caricaDocumentoDocumentiDoganaliEmessi';
          break;
        case 'documenti-doganali-ricevuti':
          userSettingsLocalStorageName = 'caricaDocumentoDocumentiDoganaliRicevuti';
          break;
        case 'modello-unico-dichiarazione-ambientale':
          userSettingsLocalStorageName = 'caricaDocumentoModelloUnicoDichiarazioneAmbientale';
          break;
        case 'note-spese-e-trasferte':
          userSettingsLocalStorageName = 'caricaDocumentoNoteSpeseETrasferte';
          break;
        case 'pod':
          userSettingsLocalStorageName = 'caricaDocumentoPOD';
          break;
        case 'bilanci':
          userSettingsLocalStorageName = 'caricaDocumentoBilanci';
          break;
      }

      let conservazioneClasseDocumentale = {
        'value': $scope.settings.classeDocumentale.key,
        'label': $scope.getClasseDocumentaleNameByKey($scope.settings.classeDocumentale.key),
        'userSettingsLocalStorageName': userSettingsLocalStorageName
      };

      store.set('conservazioneClasseDocumentale', conservazioneClasseDocumentale);
      $state.go('home.conservazione-carica-documento-' + $scope.settings.classeDocumentale.key + '-step2');
    };

    $scope.getClasseDocumentaleNameByKey = (classeDocumentale) => {
      let classeDocumentaleName = '';

      ng.forEach($scope.classeDocumentale, (value, key) => {
        if (value.key === classeDocumentale) {
          classeDocumentaleName = value.name;
        }
      });

      return classeDocumentaleName;
    };

    let getClasseDocumentaleObjectByKey = (classeDocumentale) => {
      let classeDocumentaleObject;

      ng.forEach($scope.classeDocumentale, (value, key) => {
        if (value.key === classeDocumentale) {
          classeDocumentaleObject = value;
        }
      });

      return classeDocumentaleObject;
    };

    // <editor-fold desc='getConservazioneSettings'>
    $scope.getConservazioneSettings = () => {
      $rootScope.readyToUse = false;

      if (typeof $scope.settings.classeDocumentale === 'string') {
        $scope.settings.classeDocumentale = getClasseDocumentaleObjectByKey($scope.settings.classeDocumentale);
      }

      $scope.currentClasseDocumentale = $scope.settings.classeDocumentale;

      ArchiSmallServices.getConservazioneSettings($scope.settings.classeDocumentale.key)
        .then((response: any) => {
          if (response && response !== '') {
            $scope.settings = response.value;
            $scope.settings.classeDocumentale = $scope.currentClasseDocumentale;

            $scope.filesIndex = $scope.settings.files.length;
            $rootScope.filesUploadedNumber = $scope.filesIndex;
          } else {
            $scope.settings = getSettingsDefault();
            $scope.settings.classeDocumentale = $scope.currentClasseDocumentale;
            $scope.filesIndex = $scope.settings.files.length;
            $rootScope.filesUploadedNumber = $scope.filesIndex;
          }
          $rootScope.readyToUse = true;
          $scope.ResponseReceivedTimeout = false;
        }, (error) => {
          $rootScope.alert('error', error);
        });
      $timeout(() => {
        if (!$rootScope.readyToUse) {
          $scope.ResponseReceivedTimeout = true;
        }
      }, configuration.requestWebserviceTimeoutMilliseconds);
    };

    $scope.setConservazioneSettings = () => {
      let classeDocumentale = $scope.settings.classeDocumentale.key;

      let userSettings = {
        'key': classeDocumentale,
        'value': $scope.settings
      };

      ArchiSmallServices.setConservazioneSettings(userSettings)
        .then((response: any) => {
          // ?
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };
    // </editor-fold>

    if ($state.params.classeDocumentale !== '') {
      $scope.checkOption($state.params.classeDocumentale);
    } else {
      $rootScope.filesUploadedNumber = 0;
    }
  }
}

export const ConservazioneCaricaDocumentoStep1Component: ng.IComponentOptions = {
  template: require('./conservazione-carica-documento-step1.html'),
  controller: ConservazioneCaricaDocumentoStep1Controller
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-step1/conservazione-carica-documento-step1.ts